export default "__VITE_ASSET__DoAluD59__"